
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-delivery/subscriptions-and-consent",
      function () {
        return require("private-next-pages/native-delivery/subscriptions-and-consent.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-delivery/subscriptions-and-consent"])
      });
    }
  